import { useState, useEffect, useContext } from 'react'
import { ModalEstadoContext } from '../../contexts/ModalEstado'
import { listarSuporteOrganizacoes } from '../../services/suporte'
import { suporteListaResposta } from '../../interfaces/suporte'
import Permissoes from '../../middleware/Permissoes'
import menuOpcoes from '../../interfaces/propsMenuOpcoes'
import SubMenuOpcoes from '../SubMenuOpcoes'

function MenuGesttor(props: menuOpcoes) {

    const { atualizarInformacoes } = useContext(ModalEstadoContext)

    const [atendimento, setAtendimento] = useState(0)
    const [bug, setBug] = useState(0)
    const [melhoria, setMelhoria] = useState(0)
    const [conquista, setConquista] = useState(0)

    const [subMenu, setSubMenu] = useState(false)

    const [caixaEntrada, setCaixaEntrada] = useState(0);

    function exibirSubmenu() {
        setSubMenu(subMenu => !subMenu)
    }

    useEffect(() => {

        const buscarSuporte = async () => {

            const usuarioLogado = localStorage.getItem('usuarioGesttor')

            if(!usuarioLogado) return

            const paramsSuporte = {
                pagina: 1,
                termo: '',
                tipo: 'suporte',
                status: '',
                nomeFantasia: '',
                solicitanteTermo: '',
                idResponsavel: usuarioLogado
            }

            const paramsBug = {
                pagina: 1,
                termo: '',
                tipo: 'bug',
                status: '',
                nomeFantasia: '',
                solicitanteTermo: '',
                idResponsavel: usuarioLogado
            }

            const paramsSugestao = {
                pagina: 1,
                termo: '',
                tipo: 'sugestão',
                status: '',
                nomeFantasia: '',
                solicitanteTermo: '',
                idResponsavel: usuarioLogado
            }

            const paramsConquista = {
                pagina: 1,
                termo: '',
                tipo: 'conquista',
                status: '',
                nomeFantasia: '',
                solicitanteTermo: '',
                idResponsavel: usuarioLogado
            }

            const paramsCaixaEntrada = {
                pagina: 1,
                termo: '',
                tipo: '',
                status: '',
                nomeFantasia: '',
                solicitanteTermo: '',
                idResponsavel: ''
            }

            const promisses = [
                await listarSuporteOrganizacoes(paramsSuporte),
                await listarSuporteOrganizacoes(paramsBug),
                await listarSuporteOrganizacoes(paramsSugestao),
                await listarSuporteOrganizacoes(paramsConquista),
                await listarSuporteOrganizacoes(paramsCaixaEntrada),
            ]

            try {

                const resposta = await Promise.all(promisses)

                const suporte = resposta[0]
                const bug = resposta[1]
                const sugestao = resposta[2]
                const solicitacoesRecompensas = resposta[3]
                const caixaEntrada = resposta[4]

                if (suporte.status === 200) {
                    setAtendimento(suporte.data.filter((s: suporteListaResposta) => s.status !== 'finalizado' && s.tipo === 'suporte').length)
                }

                if (bug.status === 200) {
                    setBug(bug.data.filter((s: suporteListaResposta) => s.status !== 'concluído' && s.tipo === 'bug').length)
                }

                if (sugestao.status === 200) {
                    setMelhoria(sugestao.data.filter((s: suporteListaResposta) => s.status !== 'finalizado' && s.tipo === 'sugestão').length)
                }

                if (solicitacoesRecompensas.status === 200) {
                    setConquista(solicitacoesRecompensas.data.filter((s: suporteListaResposta) => s.status !== 'finalizado' && s.tipo === 'conquista').length)
                }

                if (caixaEntrada.status === 200) {
                    setCaixaEntrada(caixaEntrada.data.length)
                }

            } catch {

            }
        }

        buscarSuporte()

    }, [atualizarInformacoes])


    return (

        <div>
            <div id='menuOpcoes' onClick={exibirSubmenu}>
                {<img id='iconeMenu' src={props.icone} alt={props.alt}></img>}
                <p id='tituloMenu'>{props.titulo}</p>
                {(caixaEntrada + atendimento + bug + melhoria + conquista) !== 0 ? <h2>{caixaEntrada + atendimento + bug + melhoria + conquista}</h2> : null}
            </div>
            <div id='submenuOpcoes'>
                <Permissoes permissoes={['master', 'administrativo', 'gesttor_licenca']}>
                    {subMenu && <SubMenuOpcoes redirect='/gesttor/cliente' texto='Gerenciar Licenças' />}
                </Permissoes>
                <Permissoes permissoes={['master', 'administrativo', 'gesttor_caixa_entrada']}>
                    {subMenu && <SubMenuOpcoes redirect='/gesttor/ajuda?tipo=' texto='Caixa de Entrada' notificacao={caixaEntrada === 0 ? null : caixaEntrada} />}
                </Permissoes>
                <Permissoes permissoes={['master', 'administrativo', 'suporte', 'gesttor_atendimento']}>
                    {subMenu && <SubMenuOpcoes redirect='/gesttor/ajuda?tipo=suporte' texto='Solicitações de Atendimento' notificacao={atendimento === 0 ? null : atendimento} />}
                </Permissoes>
                <Permissoes permissoes={['master', 'administrativo', 'gesttor_suporte']}>
                    {subMenu && <SubMenuOpcoes redirect='/gesttor/ajuda?tipo=bug' texto='Bugs Reportados' notificacao={bug === 0 ? null : bug} />}
                </Permissoes>
                <Permissoes permissoes={['master', 'administrativo', 'gesttor_melhoria']}>
                    {subMenu && <SubMenuOpcoes redirect='/gesttor/ajuda?tipo=sugestão' texto='Sugestão de Melhoria' notificacao={melhoria === 0 ? null : melhoria} />}
                </Permissoes>
                <Permissoes permissoes={['master', 'administrativo', 'gesttor_recompensa']}>
                    {subMenu && <SubMenuOpcoes redirect={'/gesttor/ajuda?tipo=conquista'} texto='Solicitações de Recompensas' notificacao={conquista === 0 ? null : conquista} />}
                </Permissoes>
            </div>
        </div>
    )
}

export default MenuGesttor
